// extracted by mini-css-extract-plugin
module.exports = {"container":"new-landing_container__Xya29"};